export interface IPaymentInfoDTO {
  card_type: string;
  exp_month: number;
  exp_year: number;
  last4: string;
}

export class PaymentInfoDTO implements IPaymentInfoDTO {
  card_type: string;
  exp_month: number;
  exp_year: number;
  last4: string;

  constructor(data: Partial<PaymentInfoDTO>) {
    this.card_type = data?.card_type ?? '';
    this.exp_month = data?.exp_month ?? 0;
    this.exp_year = data?.exp_year ?? 0;
    this.last4 = data?.last4 ?? '';
  }
}
